// 产品列表
export const GET_IS_DISABLE_PRODUCTS_SCROLL_LOADING = 'GET_IS_DISABLE_PRODUCTS_SCROLL_LOADING'
export const SET_IS_DISABLE_PRODUCTS_SCROLL_LOADING = 'SET_IS_DISABLE_PRODUCTS_SCROLL_LOADING'
export const GET_CURRENT_PRODUCTS_PAGE = 'GET_CURRENT_PRODUCTS_PAGE'
export const GET_PRODUCTS_INFO = 'GET_PRODUCTS_INFO'
export const GET_PRODUCT_TYPE_LIST = 'GET_PRODUCT_TYPE_LIST'
export const SET_PRODUCT_TYPE_LIST = 'SET_PRODUCT_TYPE_LIST'

export const GET_PRODUCT_LIST = 'GET_PRODUCT_LIST'
export const SET_PRODUCT_LIST = 'SET_PRODUCT_LIST'

// 产品详情
export const GET_PRODUCT_DETAILS = 'GET_PRODUCT_DETAILS'
export const SET_PRODUCT_DETAILS = 'SET_PRODUCT_DETAILS'

// 查看指定用户的指定产品的可用额度
export const GET_AVAILABLE_AMOUNT = 'GET_AVAILABLE_AMOUNT'

// 申请产品额度
export const GET_APPLICATION_QUOTA = 'GET_APPLICATION_QUOTA'



// WEBPACK FOOTER //
// ./src/vuex/types/products.js